class MaintenanceModal extends HTMLElement {
    constructor() {
        super();

        this.checkLocalStorage();
    }

    checkLocalStorage() {
        let maintenanceMode = localStorage.getItem('maintenanceModeDismissed');
        if (maintenanceMode == 'true') {
            document.querySelector('.maintenance-popup-modal').remove();
            document.querySelector('.maintenance-popup-password-modal').remove();
            document.body.classList.remove('overflow-hidden');
        }
    }
}

customElements.define('maintenance-modal', MaintenanceModal);

class MaintenancePasswordModal extends HTMLElement {
    element = null;

    constructor() {
        super();
        this.element = document.getElementById('maintenance-popup-modal-password-form');
        this.element.addEventListener('submit', this.formSubmit.bind(this));
    }

    formSubmit(event) {
        event.preventDefault();
        const passwordValue = this.element.querySelector('input[name="password"]').value;
        this.validatePasswordMatch(passwordValue);
    }

    validatePasswordMatch(passwordValue) {
        const maintenancePassword = this.element.querySelector('input[name="maintenance_password"]').value;
        if (passwordValue === maintenancePassword) {
            this.addLocalStorageItem();
        } else {
            this.element
                .querySelector('.global-message--error')
                .classList.add('global-message--active');
        }
    }

    addLocalStorageItem() {
        localStorage.setItem('maintenanceModeDismissed', 'true');
        document.querySelector('.maintenance-popup-modal').remove();
        document.querySelector('.maintenance-popup-password-modal').remove();
        document.body.classList.remove('overflow-hidden');
    }
}

customElements.define('maintenance-password-modal', MaintenancePasswordModal);
